import React, { ReactNode } from "react";
import Style from "./styles/Builder";
import { CustomizeGlobalProvider } from "../../context/customize/global/context";
import AuthProvider from "../../auth";

const BuilderContainer: React.FC<{ children?: ReactNode }> = ({ children }) => {
	return (
		<CustomizeGlobalProvider>
			<Style />
			<AuthProvider>{children}</AuthProvider>
		</CustomizeGlobalProvider>
	);
};

export default BuilderContainer;
